export default "__VITE_ASSET__BACN0Mpb__"